export default "__VITE_ASSET__e72cb09d__"